import React, { FC, ReactNode, CSSProperties } from 'react'
import { Body, Header, Title, Main, Loading } from './style'
import { Spin } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'

interface BlockProps {
  title?: ReactNode,
  description?: ReactNode,
  children?: ReactNode,
  loading?: boolean,
  showBack?: boolean
  style?: CSSProperties
}

const Block: FC<BlockProps> = (props) => {
  return (
    <Body>
      {
        props.title || props.description ?
          <Header>
            <Title>
              {
                props.showBack &&
                <ArrowLeftOutlined
                  style={{ marginRight: 10 }}
                  onClick={() => window.history.back()}
                />}
              {props.title ? props.title : <div />}
            </Title>
            <div>{props.description ? props.description : <div />}</div>
          </Header>
          : null
      }
      <Main style={props.style}>{props.children}</Main>
      {props.loading ? <Loading><Spin size="large" /></Loading> : null}
    </Body>
  )
}

export default Block
